<template>
  <div class="bg-more " style="border-top:1px solid #FFB800;" >
    <div class="container">
      <div class="row py-4 d-flex align-items-center" style="justify-content: space-between;padding: 15px;">
        <div class=" mt-3 mt-lg-0">
          <h4 class="text-more font-weight-bold">{{$t('footer.contactFormat.titleFormat')}}</h4>
          <ul class="d-flex list-unstyled mb-0 h4 justify-content-center justify-content-lg-end" style="flex-direction: column; width: 100%;">
            <li>
              <a href="mailto:operator_leapfly@yahoo.com" class="text-more d-flex align-items-center">
                <i class="fas fa-envelope text-primary"></i>
                <p class="mb-0 text-primary font-Arimo ml-2 " style="font-size: 16px;">
                  operator_leapfly@yahoo.com
                </p>
              </a>
            </li>

            <li class="mt-1">
              <p class="mb-0 text-primary font-Arimo el-icon-phone" style="font-size: 16px">+853 62813485（WeChat & WhatsApp）</p>
            </li>
          </ul>
        </div>

        <div class=" mt-3 mt-lg-0">
          <ul class="d-flex list-unstyled mb-0 h4  justify-content-lg-end" style="flex-direction: column; width: 100%;">
            <h4 class="text-more font-weight-bold">{{$t('footer.addressFormat.titleFormat')}}</h4>

            <li class="mt-1">
              <p class="mb-0 text-primary font-Arimo el-icon-location" style="font-size: 16px;">{{$t('footer.addressFormat.addressInFormat')}}</p>
            </li>
            <li class="mt-1">
              <p class="mb-0 text-primary font-Arimo" style="font-size: 16px;">{{$t('footer.addressFormat.addressInFormat2')}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class=" mt-3 mt-lg-0 text-primary font-Arimo" style="text-align:center">{{$t('footer.addressFormat.icpFormat')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
